import { TransformOff } from "@hortis/ui/icons";
import {
  RecordCard,
  RecordCardContent,
  RecordCardOverline,
  type RecordCardProps,
  RecordCardTitle,
} from "../record-card";

type LocationCardProps = {
  name: string;
  description?: string | null;
  hasGeometry: boolean;
  className?: string;
} & Pick<RecordCardProps, "variant" | "selected" | "size">;

function LocationCard({
  name,
  description,
  hasGeometry,
  ...rest
}: LocationCardProps) {
  return (
    <RecordCard className="pl-4" {...rest}>
      <RecordCardContent className="pt-0">
        <div className="flex items-center justify-between">
          <RecordCardTitle
            className="mt-0 block truncate text-grey-700"
            data-cy="location-name"
          >
            {name}
          </RecordCardTitle>
          {!hasGeometry && (
            <TransformOff
              data-cy="missing-geometry-icon"
              className="h-5 w-5 shrink-0 text-grey-700"
            />
          )}
        </div>
        <RecordCardOverline
          data-cy="location-description"
          className="line-clamp-2"
        >
          {description ?? "-"}
        </RecordCardOverline>
      </RecordCardContent>
    </RecordCard>
  );
}

export { LocationCard };
